import React from 'react';
import ReactDOM from 'react-dom';
import App from './app/App';
import * as serviceWorker from './serviceWorker';
import './i18n';
import { subscribeUser } from './subscription';
import '@stripe/stripe-js';

ReactDOM.render(<App />, document.getElementById('root'));
serviceWorker.register();
subscribeUser();
